<div *ngIf="message.type === 'update'" class="alert-message alert-color text-center">
    {{'GENERAL.NEW_VERSION' | translate}} {{message.message}} <button mat-flat-button  color="primary" (click)="refresh()">{{'GENERAL.UPDATE' | translate}}</button>
</div>

<button *ngIf="message.type === 'combination'" mat-flat-button color="primary" (click)="viewCombination()">{{'TOTESYSTEM.COMBINATIONS' | translate}}</button>
<button *ngIf="message.type === 'acc-top'" mat-flat-button color="primary" class="m-1 btn-acc-trio" (click)="viewQuoteMigliori(message.message)">Quote {{message.message | translate}}</button>

